import { useIntl } from 'react-intl';

import {
  getCohortBuilderPath,
  getCohortsPath,
  getProjectsBasePath,
} from '@verantos-dev/core-constants';
import { CohortBuilderPageTab } from '@verantos-dev/core-enums';
import { useCohortBuilderData } from '@verantos-dev/data-access-cohorts';
import { type PageTabProps } from '@verantos-dev/shared-components';

export const useCohortBuilderPageTabs = (activePageTab: CohortBuilderPageTab) => {
  const intl = useIntl();
  const { projectId, cohortId, cohortVersionId } = useCohortBuilderData();

  if (activePageTab === CohortBuilderPageTab.researchAssistant) {
    return undefined;
  }

  const pageTabs: PageTabProps[] = [
    {
      id: CohortBuilderPageTab.events,
      label: intl.formatMessage({ id: 'projects.cohortBuilderPage.pageTabs.eventsTab' }),
      isActive: activePageTab === CohortBuilderPageTab.events,
      path: projectId
        ? cohortId && cohortVersionId
          ? `${getCohortBuilderPath(projectId, cohortId, cohortVersionId)}?pageTab=${
              CohortBuilderPageTab.events
            }` // route to cohort builder if cohort id
          : getCohortsPath(projectId) // route to cohorts list if no cohort id
        : getProjectsBasePath(), // route to projects list if no project id
    },
    {
      id: CohortBuilderPageTab.definition,
      label: intl.formatMessage({ id: 'projects.cohortBuilderPage.pageTabs.definitionTab' }),
      isActive: activePageTab === CohortBuilderPageTab.definition,
      path: projectId
        ? cohortId && cohortVersionId
          ? `${getCohortBuilderPath(projectId, cohortId, cohortVersionId)}?pageTab=${
              CohortBuilderPageTab.definition
            }` // route to cohort builder if cohort id
          : getCohortsPath(projectId) // route to cohorts list if no cohort id
        : getProjectsBasePath(), // route to projects list if no project id
    },
    {
      id: CohortBuilderPageTab.results,
      label: intl.formatMessage({ id: 'projects.cohortBuilderPage.pageTabs.resultsTab' }),
      isActive: activePageTab === CohortBuilderPageTab.results,
      path: projectId
        ? cohortId && cohortVersionId
          ? `${getCohortBuilderPath(projectId, cohortId, cohortVersionId)}?pageTab=${
              CohortBuilderPageTab.results
            }` // route to cohort builder if cohort id
          : getCohortsPath(projectId) // route to cohorts list if no cohort id
        : getProjectsBasePath(), // route to projects list if no project id
    },
    // TODO: OR-3090 - add the concepts tab
    // {
    //   id: CohortBuilderPageTab.concepts,
    //   label: intl.formatMessage({ id: 'projects.cohortBuilderPage.pageTabs.conceptsTab' }),
    //   isActive: activePageTab === CohortBuilderPageTab.concepts,
    //   path: projectId
    //     ? cohortId && cohortVersionId
    //       ? `${getCohortBuilderPath(projectId, cohortId, cohortVersionId)}?pageTab=${CohortBuilderPageTab.concepts}` // route to cohort builder if cohort id
    //       : getCohortsPath(projectId) // route to cohorts list if no cohort id
    //     : getProjectsBasePath(), // route to projects list if no project id
    // },
    // TODO: OR-3088 - add the history tab
    // {
    //   id: CohortBuilderPageTab.history,
    //   label: intl.formatMessage({ id: 'projects.cohortBuilderPage.pageTabs.historyTab' }),
    //   isActive: activePageTab === CohortBuilderPageTab.history,
    //   path: projectId
    //     ? cohortId && cohortVersionId
    //       ? `${getCohortBuilderPath(projectId, cohortId, cohortVersionId)}?pageTab=${CohortBuilderPageTab.history}` // route to cohort builder if cohort id
    //       : getCohortsPath(projectId) // route to cohorts list if no cohort id
    //     : getProjectsBasePath(), // route to projects list if no project id
    // },
    // TODO: OR-3089 - add the datasets tab
    // {
    //   id: CohortBuilderPageTab.datasets,
    //   label: intl.formatMessage({ id: 'projects.cohortBuilderPage.pageTabs.datasetsTab' }),
    //   isActive: activePageTab === CohortBuilderPageTab.datasets,
    //   path: projectId
    //     ? cohortId && cohortVersionId
    //       ? `${getCohortBuilderPath(projectId, cohortId, cohortVersionId)}?pageTab=${CohortBuilderPageTab.datasets}` // route to cohort builder if cohort id
    //       : getCohortsPath(projectId) // route to cohorts list if no cohort id
    //     : getProjectsBasePath(), // route to projects list if no project id
    // },
  ];

  return pageTabs;
};
